// Plain-text preview of a product description for the product cards.
//
// Descriptions are HTML from the admin rich-text editor. The cards used to strip
// tags with a regex, which left entities such as &nbsp; showing as literal text.
// DOMParser decodes entities properly and builds an inert document: no scripts
// run and no images load. Closing block tags become spaces so "<p>a</p><p>b</p>"
// reads "a b" rather than "ab".
export const htmlToPlainText = (html) => {
  if (!html) return '';
  const spaced = String(html).replace(/<\/(p|div|li|h[1-6]|blockquote)>|<br\s*\/?>/gi, ' ');
  const doc = new DOMParser().parseFromString(spaced, 'text/html');
  return (doc.body.textContent || '')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};
